// https://github.com/d3/d3-interpolate/blob/master/src/number.js
import type { Vector3Tuple } from "three";

export function interpolateLinearDirectly(a: number, b: number, t: number) {
  const aa = +a
  const bb = b - a
  return aa + bb * t
}

export function interpolateVec3LinearDirectly(
  vec1: Vector3Tuple,
  vec2: Vector3Tuple,
  t: number
) {
  const x = interpolateLinearDirectly(vec1[0], vec2[0], t)
  const y = interpolateLinearDirectly(vec1[1], vec2[1], t)
  const z = interpolateLinearDirectly(vec1[2], vec2[2], t)
  return [x, y, z] as Vector3Tuple
}
